export default __webpack_public_path__ + "static/media/twitter-icon.d29373f7.svg";